import React from 'react';
import { MessageSquareText, Star, ListChecks } from 'lucide-react';
import { Panel } from '@/components/responseDetail/Panel';
import { FeedbackItem, RatingItem, GenericItem, Stars } from '@/components/responseDetail/AnswerViews';

const LEGACY_RATINGS = [
  ['Overall', 'overall_experience'], ['Food', 'food_quality'], ['Service', 'service_efficiency'],
  ['Ambience', 'ambience'], ['Cleanliness', 'cleanliness'], ['Environment', 'environment'],
];

// Pre-builder responses stored feedback on top-level fields.
export function legacyFeedbackItems(r) {
  const out = [];
  [['nps_reason', 'Feedback'], ['suggestions', 'Suggestions']].forEach(([k, label]) => {
    const url = r[`${k}_voice_url`];
    if (!r[k] && !url) return;
    out.push({ qid: `legacy-${k}`, q: { text: label }, val: url ? { audio_url: url, text: r[k] || '' } : r[k] });
  });
  return out;
}

export function FeedbackPanel({ items, responseId, derived, profaneAudio }) {
  if (!items.length) return null;
  return (
    <Panel title="Written & Voice Feedback" icon={MessageSquareText} testId="feedback-panel">
      {items.map((it) => <FeedbackItem key={it.qid} item={it} responseId={responseId} derived={(derived || {})[it.qid]} warnAudio={profaneAudio?.has(it.qid)} />)}
    </Panel>
  );
}

export function RatingsPanel({ items, legacy }) {
  const legacyRows = LEGACY_RATINGS.filter(([, k]) => Number(legacy?.[k]) > 0);
  if (!items.length && !legacyRows.length) return null;
  return (
    <Panel title="Ratings" icon={Star} testId="ratings-panel">
      <div className="space-y-4">
        {items.map((it) => <RatingItem key={it.qid} item={it} />)}
        {legacyRows.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8" data-testid="legacy-ratings">
            {legacyRows.map(([label, k]) => (
              <div key={k} className="flex items-center justify-between py-2 border-b border-[#F1F5F9]">
                <span className="text-sm text-[#0F172A]">{label}</span>
                <Stars value={legacy[k]} />
              </div>
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
}

export function OtherAnswersPanel({ items, responseId }) {
  if (!items.length) return null;
  return (
    <Panel title="Other Answers" icon={ListChecks} testId="other-answers-panel">
      {items.map((it) => <GenericItem key={it.qid} item={it} responseId={responseId} />)}
    </Panel>
  );
}
